import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { ProductCategoryTable } from '@app/components/apps/ProductCategories/ProductCategoryTable';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';

const AllProductCategories: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, removeHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  function handleCreateClick(): void {
    navigate('/add-product-category');
  }

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[{ path: '/product-categories', breadcrumbName: 'Product Categories' }]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'Add Product Category',
      <BaseButton type="primary" size="small" onClick={handleCreateClick}>
        Create
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, []);

  return (
    <>
      <PageTitle>Product Categories</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ProductCategoryTable />
        </Col>
      </Row>
    </>
  );
};

export default AllProductCategories;
